"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._base_barchart_ui_configs = void 0;
/**
* if any changes are being made to the spacing and such of
  this comps design, all these properties need to be carefully
  observed and tweaked to ensure no ui has gotten warped due to sideeffects
*/
exports._base_barchart_ui_configs = {
    //4 of these compose a single bar section
    barHeight: 10,
    labelToBarGap: 6,
    labelHeight: 16.5667,
    labelToNextBarGap: 14,
    //other bar section related properties
    barRadius: 2,
    gapBetweenBarSections: 0,
    hoverRectStrokeWidth: 1,
    //overall chart margin
    marginLeft: 6,
    marginRight: 6,
    //grouped bar chart related properties
    gapBetweenBarsInGroup: 3,
};
